export const DISCORD_CHANNEL = 'https://discord.gg/colonist';
